// extracted by mini-css-extract-plugin
module.exports = {"Main":"IntegratedApp_Main__36JwY"};